import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { LOCAL_STORAGE_KEYS } from "consts";
import { CustomAccordion } from "../components";
import { VarianceChart, CombinedChart } from "../../charts";
import { DropdownProps } from "../types";

const VarianceDropdown = ({ searchFilters, subTypeChart, currentMainTab }: DropdownProps) => {
  const currentDate = dayjs.utc();

  const storedVarianceStartDate = localStorage.getItem(LOCAL_STORAGE_KEYS.DASHBOARD_PAGE_VARIANCE_START_DATE);
  const storedVarianceEndDate = localStorage.getItem(LOCAL_STORAGE_KEYS.DASHBOARD_PAGE_VARIANCE_END_DATE);

  const isValidVarianceStartDate = storedVarianceStartDate && storedVarianceStartDate !== "";
  const isValidVarianceEndDate = storedVarianceEndDate && storedVarianceEndDate !== "";

  const [varianceStartDate, setVarianceStartDate] = useState<Dayjs>(isValidVarianceStartDate ? dayjs(storedVarianceStartDate) : dayjs(currentDate.date(1)).subtract(2, "month"));
  const [varianceEndDate, setVarianceEndDate] = useState<Dayjs>(isValidVarianceEndDate ? dayjs(storedVarianceEndDate) : dayjs(currentDate));

  return <CustomAccordion
    titleAccordion="Variance"
    panelNumber={1}
    allowDates
    startDate={varianceStartDate}
    endDate={varianceEndDate}
    setStartDate={setVarianceStartDate}
    setEndDate={setVarianceEndDate}>
    <VarianceChart
      startDate={varianceStartDate}
      endDate={varianceEndDate}
      subTabName={subTypeChart}
      searchFilters={searchFilters}
      chartTitle="Comparing Current Period, Same Period Last Year"
      currentMainTab={currentMainTab}
    />
    <CombinedChart
      startDate={varianceStartDate}
      endDate={varianceEndDate}
      subTabName={subTypeChart}
      chartTitle="Variance Absolute and Percentage Amounts"
      searchFilters={searchFilters}
      currentMainTab={currentMainTab}
    />
  </CustomAccordion>
}

export default VarianceDropdown;